<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot></slot>
      </span>
    </template>
    <span>
      <slot name="tip"></slot>
    </span>
  </v-tooltip>
</template>

<script>
export default {};
</script>

<style>
</style>